"use client";

import { useEffect } from "react";
import type { Product } from "@/lib/products";
import { trackProductView } from "@/lib/analytics/events";

interface ProductViewTrackerProps {
  product: Product;
}

/**
 * Product View Tracker Component
 * Tracks product page views to analytics platforms
 */
export default function ProductViewTracker({ product }: ProductViewTrackerProps) {
  useEffect(() => {
    trackProductView({
      slug: product.slug,
      name: product.name,
      alternateName: product.alternateName,
      price: product.offers?.lifetime?.price || "0",
      category: "Chrome Extension",
    });
  }, [product.slug, product.name, product.alternateName, product.offers]);

  // This component renders nothing
  return null;
}
